export interface LoginPageDeps {
  navigate?: (path: string) => void;
  /** テスト用に注入可能。既定は`window.location.search`を読む */
  queryString?: string;
  /** テスト用に注入可能。既定はグローバルfetch */
  fetchImpl?: typeof fetch;
}

interface LoginPageElements {
  loginBtn: HTMLButtonElement;
  errorMsg: HTMLElement;
  portalLink: HTMLAnchorElement;
}

function buildDom(container: HTMLElement): LoginPageElements {
  container.innerHTML = `
    <main>
      <div class="login-card">
        <p class="app-name" data-item-id="header-1">ccterm</p>
        <button type="button" class="primary" id="loginBtn" data-item-id="login-1">
          <span class="spinner" data-item-id="login-2"></span>
          <span>xauthでログイン</span>
        </button>
        <div class="message error" id="errorMsg" data-item-id="error-1"></div>
        <a class="portal-link" id="portalLink" data-item-id="login-3" target="_blank" rel="noopener" hidden>xauthのアカウント管理・ログアウトはこちら</a>
      </div>
    </main>
  `;

  return {
    loginBtn: container.querySelector("#loginBtn") as HTMLButtonElement,
    errorMsg: container.querySelector("#errorMsg") as HTMLElement,
    portalLink: container.querySelector("#portalLink") as HTMLAnchorElement,
  };
}

function errorMessage(error: string): string {
  if (error === "access_denied") {
    return "アクセスが許可されませんでした";
  }
  return "ログインに失敗しました。しばらく時間をおいて再度お試しください";
}

export function renderLoginPage(container: HTMLElement, deps: LoginPageDeps = {}): void {
  const navigate = deps.navigate ?? ((path: string) => window.location.assign(path));
  const fetchImpl = deps.fetchImpl ?? fetch;
  const elements = buildDom(container);

  const params = new URLSearchParams(deps.queryString ?? window.location.search);
  const error = params.get("error");
  if (error) {
    elements.errorMsg.textContent = errorMessage(error);
    elements.errorMsg.classList.add("show");
  }

  // 再認証後に元の画面へ戻すための復帰先。検証（受け付けてよいパスか）はサーバー側が行う
  const returnTo = params.get("returnTo");
  const loginPath = returnTo ? `/api/auth/login?returnTo=${encodeURIComponent(returnTo)}` : "/api/auth/login";

  elements.loginBtn.addEventListener("click", () => {
    elements.loginBtn.classList.add("loading");
    elements.loginBtn.disabled = true;
    navigate(loginPath);
  });

  fetchImpl("/api/auth/portal-url")
    .then((res) => (res.ok ? (res.json() as Promise<{ url?: string }>) : undefined))
    .then((data) => {
      if (data?.url) {
        elements.portalLink.href = data.url;
        elements.portalLink.hidden = false;
      }
    })
    .catch(() => {
      // ポータルURLが取得できなくてもログイン自体は継続できるため、リンクを表示しないだけに留める
    });
}
